import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useSupplierBrands(family, suppliers) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarMarcasProveedores.php", {
      token: userData.token,
      familia: family,
      proveedores: suppliers,
    });
    setList([...response.map((e) => ({ id: e, text: e }))]);
  }

  useEffect(() => {
    getData();
  }, [family, JSON.stringify(suppliers)]);

  return list;
}
